import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';

import Spinner from '../../components/UI/Spinner';
import ViewSettlementsForm from '../../components/Forms/ViewSettlementsForm';
import SettlementListItem from '../../components/Settlement/SettlementListItem';
import Aux from '../../hoc/NoParent';
import AjaxErrorMessage from '../../components/UI/AjaxErrorMessage';

import { loadSettlementsFromServer, loadSettlementsFromCache } from '../../store/actions/index';
import { getServerFormattedDate, getISOFormattedDate } from '../../util/getFormattedDate';
import { getNextFriday } from '../../util/dateUtil';

class Settlements extends Component {
    state = {
        downloadedSettlements: []
    }

    componentDidMount() {
        this.props.loadSettlementsFromCache();
    }

    onSubmitForm = ({start, end}) => {
        this.props.loadSettlementsFromServer(getServerFormattedDate(start), getServerFormattedDate(end), this.props.token);
    }

    onDownloadSettlement = (check_id) => {
        this.setState((state) => {
            return {
                downloadedSettlements: [...state.downloadedSettlements, check_id]
            };
        });
    }

    render() {
        let settlementsGrid = this.props.loading ? <Spinner /> : null;
        let i = 1;
        const downloadedSettlements = this.state.downloadedSettlements.map(check_id => <iframe title={`Download${i}`} key={i++} src={`https://portals.leonardsexpress.com/driver/lite/settlements/download/${check_id}?token=${this.props.token}`} frameBorder="0" style={{width: '1px', height: '1px'}}></iframe>);

        if(!this.props.loading && this.props.settlements !== null) {
            settlementsGrid = (
                <Grid container spacing={2} style={{padding: '0px 24px', width: '100%'}}>
                {
                    this.props.settlements.map(settlement => {
                        return (
                            <Grid item key={settlement.check_id} xs={12} sm={6} lg={4} xl={3}>
                                <SettlementListItem 
                                    onDownloadSettlement={(check_id) => this.onDownloadSettlement(check_id)}
                                    settlement={settlement} />
                            </Grid>
                        );
                    })
                }
                </Grid>
            );
        }

        const now = new Date();
        const initialStartDate = getNextFriday(new Date(now.setDate(now.getDate() - 30)));
        const initialEndDate = getNextFriday(new Date());

        const initialFormValues = {
            start: getISOFormattedDate(initialStartDate), 
            end: getISOFormattedDate(initialEndDate)
        }

        return (
            <Aux>
                <ViewSettlementsForm initialValues={initialFormValues} onSubmit={this.onSubmitForm} />
                {settlementsGrid}
                {downloadedSettlements}
                <AjaxErrorMessage error={this.props.error} />
            </Aux>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        settlements: state.settlement.settlements, 
        token: state.auth.token, 
        loading: state.settlement.loading, 
        error: state.settlement.error 
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadSettlementsFromServer: (start, end, token) => dispatch(loadSettlementsFromServer(start, end, token)), 
        loadSettlementsFromCache: () => dispatch(loadSettlementsFromCache())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settlements);